export const ru = {
    copied: 'Скопировано',
    'copy-error': 'Ошибка при копировании',
    'copy-link': 'Копировать условия в буфер обмена',
    metrikaAudience: 'Яндекс.Аудитории и Яндекс.Метрика',
    'open-popup-text': 'Посмотреть условия показа',
    'popup-title': 'Условия показа',
    'users-profiles': 'Профиль пользователя'
};
